import getColorCodeColorValueMap from './helpers/getColorCodeColorValueMap';
import CategoryStore from './schema/CategoryStore';
import { createStore } from 'satcheljs';

let defaultCategoryStore = {
    categoryIdToNameMap: {},
    categoryMenuViewState: {
        findText: '',
        isFocusInSearchBox: false,
        newCategoryViewState: null,
        shouldShowAllCategories: false,
    },
    categoryColorPickerViewState: {
        colorPickerTarget: null,
        shouldShowColorPicker: false,
    },
    colorCodeColorValueMap: getColorCodeColorValueMap(),
    pendingCategoryNamesMap: {},
};

export const getStore = createStore<CategoryStore>('category', defaultCategoryStore);
export default getStore();
